import common from "./zh-CN/common"
import home from "./zh-CN/home"
import query from './zh-CN/query'
import track from './zh-CN/track'
import contact from './zh-CN/contact'
import about from './zh-CN/about'

export default {
    ...common,
    ...home,
    ...about,
    ...query,
    ...track,
    ...contact
}